<template>
  <div>
    <div
      class="chat-toggle__container"
      :class="[classes, {'dark-theme': isDarkTheme && hasPillWrapper,
                         'white-theme-w-image': isWhiteThemeWithImage && hasPillWrapper,
                         'chat-toggle--pill': hasPillWrapper}]"
      @click="toggleChatBox()"
    >
      <aha-icon
        name="chat-canvas"
        class="chat-toggle__icon"
        v-if="!hasChatNotification"
      />
      <aha-icon
        name="chat-canvas-noti"
        class="chat-toggle__icon has-noti"
        v-else
      />
    </div>
    <div class="chat-box__tip" :class="{'dark': isDarkTheme}" v-if="chatBoxVisible" />
    <slot v-if="chatBoxVisible" />
  </div>
</template>
<script>
export default {
  name: 'ChatToggle',
  props: {
    classes: {
      type: String,
      default: '',
    },
    chatBoxVisible: {
      type: Boolean,
      default: false,
    },
    hasChatNotification: {
      type: Boolean,
      default: false,
    },
    isDarkTheme: {
      type: Boolean,
      default: false,
    },
    isWhiteThemeWithImage: {
      type: Boolean,
      default: false,
    },
    hasPillWrapper: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggleChatBox() {
      this.$emit('toggleChatBox')
    },
  },
}
</script>
<style lang="scss" scoped>
.chat-toggle--pill {
  padding: 7px 16px;
  cursor: pointer;

  &::after {
    background: rgba(175, 175, 175, 0.3);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-radius: 27px;
    display: block;
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }

  &.white-theme-w-image {
    &::after {
      background: rgba(255, 255, 255, 0.5);
    }
  }

  &.dark-theme {
    &::after {
      background: rgba(0, 0, 0, 0.36);
    }
  }
}
.chat-toggle__container {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  .chat-toggle__icon {
    width: 30px;
    padding-left: 1px;
    margin-bottom: 1px;
    &.has-noti {
      padding-left: 0;
    }
  }
}
.chat-box__tip {
  position: absolute;
  width: 13px;
  z-index: 1;
  height: 13px;
  top: -29px;
  left: 1rem;
  background:#ffffff;
  transform: translate(-50%, 0) rotate(45deg);
  border-bottom-right-radius: 2px;
  outline: none;
  &.dark {
    background: #000000;
    box-shadow: 2px 2px 3px rgba(255, 255, 255, 0.04);
  }
}
</style>
